//------------------------REACT ESSENTIALS------------------------//
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

// ------------------------ COMPONENTS ------------------------//
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import { convertedColumnName, getTableColumns, noRowsTemplate } from "../../common";
import { DataGrid, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarColumnsButton } from "@mui/x-data-grid";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import moment from "moment";

// ------------------------ REDUX ------------------------//
import { useDispatch, useSelector } from "react-redux";
import { getAreaGroupListPlanned, getMainEquipmentListPlanned, getSubEquipmentListPlanned, getSubEquipmentsTaskListPlanned, getMaintenanceTypeData, getPoolData } from "../../store/actions/MachineMaintenanceSummaryListPlannedActions";

// ------------------------ STYLES ------------------------//
import { Collapse, Grow, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";
import LinearProgress from '@mui/material/LinearProgress';
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import FilterButton from "../../components/FilterButton/FilterButton";
import DetailFilter from "../../components/DetailFilter/DetailFilter";

const useStyles = makeStyles((_theme) => ({
    areaTableCellStyle: {
        backgroundColor: "rgb(198,218,214)",
        color: "black"
    },
    mainEquipmentTableCellStyle: {
        backgroundColor: "#EAF2E8",
        color: "black"
    },
    subEquipmentTableCellStyle: {
        backgroundColor: "#f6f9f5",
        color: "black"
    },
    taskTableCellStyle: {
        backgroundColor: "aliceblue",
        width: "2160px",
        color: "black"
    },
    expandArrowStyle: {
        color:"#3C9CC0"
    }
}));

export default function MachineMaintenanceSummaryList(props) {
    const { t } = useTranslation("translation");
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [sortItem, setSortItem] = useState(null);

    const { areaGroupListPlanned, mainEquipmentListPlanned, subEquipmentListPlanned, subEquipmentsTaskListPlanned, maintenanceTypes, poolList } = useSelector(({ MachineMaintenanceSummaryListPlanned }) => MachineMaintenanceSummaryListPlanned);

    const [areaGroupData, setAreaGroupData] = useState([]);
    const [mainEquipmentData, setMainEquipmentData] = useState([]);
    const [subEquipmentData, setSubEquipmentData] = useState([]);
    const [subEqTaskList, setsubEqTaskList] = useState([]);
    const [poolData, setPoolData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [areaGroupCount, setAreaGroupCount] = useState(0);
    const [mainEquipmentCount, setMainEquipmentCount] = useState(0);
    const [subEquipmentCount, setSubEquipmentCount] = useState(0);
    const [subEqTaskListCount, setsubEqTaskListCount] = useState(0);
    

    useEffect(() => {
        setAreaGroupCount(areaGroupListPlanned?.resultObject?.totalCount)
        areaGroupListPlanned?.resultObject ? setAreaGroupData(areaGroupListPlanned?.resultObject?.content) : setAreaGroupData([]);
    }, [areaGroupListPlanned]);

    useEffect(() => {
        setMainEquipmentCount(mainEquipmentListPlanned?.resultObject?.totalCount)
        mainEquipmentListPlanned?.resultObject ? setMainEquipmentData(mainEquipmentListPlanned.resultObject.content) : setMainEquipmentData([]);
    }, [mainEquipmentListPlanned]);

    useEffect(() => {
        setSubEquipmentCount(subEquipmentListPlanned?.resultObject?.totalCount)
        subEquipmentListPlanned?.resultObject ? setSubEquipmentData(subEquipmentListPlanned.resultObject.content) : setSubEquipmentData([]);
    }, [subEquipmentListPlanned]);

    useEffect(() => {
        setsubEqTaskListCount(subEquipmentsTaskListPlanned?.resultObject?.totalCount)
        subEquipmentsTaskListPlanned?.resultObject ? setsubEqTaskList(subEquipmentsTaskListPlanned.resultObject.content) : setsubEqTaskList([]);
        setLoading(false);
    }, [subEquipmentsTaskListPlanned]);

    //load area data first
    useEffect(() => {
        fetchAreaList();
        dispatch(getMaintenanceTypeData());
        dispatch(getPoolData());
    }, []);

    useEffect(() => {
        if(poolList){
            setPoolData(poolList.resultObject)
        }
    }, [poolList]);



    const fetchAreaList = (pageNumber = areaGroupCurrentPage, pageSize = areaGrouprowsPerPage) => {
        const data = {
            equipmentId: 0,
            areaId: 0,
            mainEquipmentId: 0,
            breakdownEffectIds: [],
            breakdownReasonGroupIds: [],
            breakdownRootCauseIds: [],
            breakdownReasonPlaceIds: []
        };

        let payload = { ...state,
            groupingParameter: data,
            currentPage: pageNumber + 1,
            pageSize: pageSize
            
        };
        dispatch(getAreaGroupListPlanned(payload));
    };

    const fetchMainEquipmentList = (pageNumber = mainEquipmentCurrentPage, pageSize = mainEquipmentRowsPerPage) => {
        const data = {
            equipmentId: 0,
            areaId: expandAreaID,
            mainEquipmentId: 0
        };
        let payload = { ...state,
            groupingParameter: data,
            currentPage: pageNumber + 1,
            pageSize: pageSize
        };

        dispatch(getMainEquipmentListPlanned(payload));
    };

    const fetchSubEquipmentList = (pageNumber = subEquipmentCurrentPage, pageSize = subEquipmentRowsPerPage) => {
        const data = {
            equipmentId: 0,
            areaId: 0,
            mainEquipmentId: expandMainEquipmentID
        };

        let payload = { ...state,
            groupingParameter: data,
            currentPage: pageNumber + 1,
            pageSize: pageSize
        };
        
        dispatch(getSubEquipmentListPlanned(payload));
    };

    const fetchSubEquipmentTaskList = (pageNumber = tasksCurrentPage, pageSize = tasksRowsPerPage) => {
        const data = {
            equipmentId: expandSubEquipmentID,
            areaId: 0,
            mainEquipmentId: 0
        };

        let payload = { ...state,
            groupingParameter: data,
            currentPage: pageNumber + 1,
            pageSize: pageSize
        };

        dispatch(getSubEquipmentsTaskListPlanned(payload));
    };



    //dynamic sort function
    let [sortOrder, setSortOrder] = useState();
    let [sortColumn, setSortColumn] = useState();
    const handleSort = (columnName) => {
        setSortItem({
            ...sortItem,
            propertyName: convertedColumnName(columnName), //Added to convert column name like "id" to "Id" because of sorting on backend-side
            direction: sortItem?.propertyName === convertedColumnName(columnName) ? invertSortDirection(sortItem?.direction) : 0,
        });
    };

    const invertSortDirection = (direction) => (direction === 0 ? 1 : 0);

    // AREA GROUP PAGINATION
    const [areaGroupCurrentPage, setAreaGroupCurrentPerPage] = useState(0);
    const [areaGrouprowsPerPage, setAreaGroupRowsPerPage] = useState(10);
    const areaGroupHandleChangePage = (_event, newPage) => {
        setAreaGroupCurrentPerPage(newPage);
        fetchAreaList(newPage, areaGrouprowsPerPage)
    };

    const areaGroupHandleChangeRowsPerPage = (event) => {
        setAreaGroupRowsPerPage(+event.target.value);
        setAreaGroupCurrentPerPage(0);
        fetchAreaList(areaGroupCurrentPage, event.target.value)
    };

    // MAIN EQUIPMENT PAGINATION
    const [mainEquipmentCurrentPage, setMainEquipmentCurrentPerPage] = useState(0);
    const [mainEquipmentRowsPerPage, setMainEquipmentRowsPerPage] = useState(10);
    const mainEquipmentHandleChangePage = (_event, newPage) => {
        setMainEquipmentCurrentPerPage(newPage);
        fetchMainEquipmentList(newPage, mainEquipmentRowsPerPage);
    };

    const mainEquipmentHandleChangeRowsPerPage = (event) => {
        setMainEquipmentRowsPerPage(+event.target.value);
        setMainEquipmentCurrentPerPage(0);
        fetchMainEquipmentList(mainEquipmentCurrentPage, event.target.value)
    };

    // SUB EQUIPMENT PAGINATION
    const [subEquipmentCurrentPage, setSubEquipmentCurrentPerPage] = useState(0);
    const [subEquipmentRowsPerPage, setSubEquipmentRowsPerPage] = useState(10);
    const subEquipmentHandleChangePage = (_event, newPage) => {
        setSubEquipmentCurrentPerPage(newPage);
        fetchSubEquipmentList(newPage, subEquipmentRowsPerPage);
    };

    const subEquipmentHandleChangeRowsPerPage = (event) => {
        setSubEquipmentRowsPerPage(+event.target.value);
        setSubEquipmentCurrentPerPage(0);
        fetchSubEquipmentList(subEquipmentCurrentPage, event.target.value)
    };

    // TASKS'S PAGINATION
    const [tasksCurrentPage, setTasksCurrentPerPage] = useState(0);
    const [tasksRowsPerPage, setTasksRowsPerPage] = useState(10);
    const tasksHandleChangePage = (event) => {
        setTasksCurrentPerPage(event);
        fetchSubEquipmentTaskList(event, tasksRowsPerPage);
    };

    const tasksHandleChangeRowsPerPage = (event) => {
        setTasksRowsPerPage(+event);
        setTasksCurrentPerPage(0);
        fetchSubEquipmentTaskList(tasksCurrentPage, event)
    };

    //EXPAND AREA GROUP ROW
    const [openAreaRow, setOpenAreaRow] = useState(false);
    const [expandAreaID, setExpandAreaId] = useState("");
    const expandAreaRow = (row) => {
        if (openAreaRow && expandAreaID !== row) {
            setExpandAreaId(row);
        } else {
            setOpenAreaRow(!openAreaRow);
            setExpandAreaId(row);
        }

        if (!openAreaRow) {
            setMainEquipmentData([]);
            setOpenMainEquipmentRow(false);
            setOpenSubEquipmentRow(false);
        }

        const data = {
            equipmentId: 0,
            areaId: row,
            mainEquipmentId: 0
        };

        let payload = { ...state,
            groupingParameter: data,
            currentPage: mainEquipmentCurrentPage,
            pageSize: mainEquipmentRowsPerPage
        };
        dispatch(getMainEquipmentListPlanned(payload));
    };

    //EXPAND MAIN EQUIPMENT ROW
    const [openMainEquipmentRow, setOpenMainEquipmentRow] = useState(false);
    const [expandMainEquipmentID, setExpandMainEquipmentId] = useState("");
    const expandMainEquipmentRow = (rowId) => {
        if (openMainEquipmentRow && expandMainEquipmentID !== rowId.mainEquipmentId) {
            setExpandMainEquipmentId(rowId.mainEquipmentId);
        } else {
            setOpenMainEquipmentRow(!openMainEquipmentRow);
            setExpandMainEquipmentId(rowId.mainEquipmentId);
        }

        if (!openMainEquipmentRow) {
            setSubEquipmentData([]);
            setOpenSubEquipmentRow(false);
        }

        const data = {
            equipmentId: 0,
            areaId: 0,
            mainEquipmentId: rowId.mainEquipmentId
        }

        let payload = { ...state,
            groupingParameter: data,
            currentPage: subEquipmentCurrentPage,
            pageSize: subEquipmentRowsPerPage
        };
        dispatch(getSubEquipmentListPlanned(payload));
    };

    //EXPAND SUB EQUIPMENT ROW
    const [openSubEquipmentRow, setOpenSubEquipmentRow] = useState(false);
    const [expandSubEquipmentID, setExpandSubEquipmentID] = useState("");
    const expandSubEquipmentRow = (rowId) => {
        if (openSubEquipmentRow && expandSubEquipmentID !== rowId.equipmentId) {
            setExpandSubEquipmentID(rowId.equipmentId);
        } else {
            setOpenSubEquipmentRow(!openSubEquipmentRow);
            setExpandSubEquipmentID(rowId.equipmentId);
        }
        setsubEqTaskList([]);
        setLoading(true);

        const data = {
            equipmentId: rowId.equipmentId,
            areaId: 0,
            mainEquipmentId: 0
        }
        let payload = { ...state,
            groupingParameter: data,
            currentPage: tasksCurrentPage,
            pageSize: tasksRowsPerPage
        };
        dispatch(getSubEquipmentsTaskListPlanned(payload));
    };

    const NavigateToDetails = (id) => {
        sessionStorage.setItem("blt_pushBreakdownDetail", tasksCurrentPage);
        sessionStorage.setItem("blt_rowsPerPage", tasksRowsPerPage);
        history.push("/planned-maintenance-detail?id=" + id);
    };

    const renderTableCell = (rowItems) => {
        return rowItems.map((item) => {
            return <TableCell align="center" id={`mmsl_TableHead_${item.id}`}>{item.label}</TableCell>;
        });
    };

    const columnVisibilityModelData = JSON.parse(localStorage.getItem("columnVisibilityModelP")) || {};
    const [columnVisibilityModel, setColumnVisibilityModel] = useState(columnVisibilityModelData);

    const customToolbar = () => {
        return (
            <GridToolbarContainer>
                <GridToolbarDensitySelector />
                <GridToolbarColumnsButton name="column" />
                {/* <GridToolbarFilterButton /> */}
            </GridToolbarContainer>
        );
    };

    const handleChangeVisibility = (newModel) => {
        setColumnVisibilityModel(newModel);
        localStorage.setItem("columnVisibilityModelP", JSON.stringify(newModel));
    };


    const initialState = {
        maintenanceTypeIds: JSON.parse(sessionStorage.getItem("mmsp_maintenanceTypeIds")) || [],
        includeOnlyLateTasks: JSON.parse(sessionStorage.getItem("mmsp_includeOnlyLateTasks")) || false,
        poolIds: JSON.parse(sessionStorage.getItem("mmsp_poolIds")) || []
    };

    const [state, setState] = useState({ ...initialState });
    const [maintenanceTypeDataF, setMaintenanceTypeDataF] = useState([]);


    const setDefaultState = () => {
        setState({
            maintenanceTypeIds:  [],
            includeOnlyLateTasks: false,
            poolIds:  [],
        });
    };
  
    useEffect(() => {
        setMaintenanceTypeDataF(maintenanceTypes)
    }, [maintenanceTypes]);

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }

        setIsFilterDrawerOpen(open);
    };
 
    const HandleClearFilter = () => {
        const dataArea = {
            equipmentId: 0,
            areaId: 0,
            mainEquipmentId: 0,
            breakdownEffectIds: [],
            breakdownReasonGroupIds: [],
            breakdownRootCauseIds: [],
            breakdownReasonPlaceIds: []
        };

        let payloadArea = {
            groupingParameter: dataArea,
            currentPage: mainEquipmentCurrentPage + 1,
            pageSize: areaGrouprowsPerPage
            
        };
        dispatch(getAreaGroupListPlanned(payloadArea));

        if(expandAreaID){
            const dataMainEquip = {
                equipmentId: 0,
                areaId: expandAreaID,
                mainEquipmentId: 0
            };
            let payloadMainEquip = {
                groupingParameter: dataMainEquip,
                currentPage: mainEquipmentCurrentPage + 1,
                pageSize: mainEquipmentRowsPerPage
            };
    
            dispatch(getMainEquipmentListPlanned(payloadMainEquip));
        }

        if(expandMainEquipmentID){
            const dataSubEquip = {
                equipmentId: 0,
                areaId: 0,
                mainEquipmentId: expandMainEquipmentID
            };
    
            let payloadSubEquip = {
                groupingParameter: dataSubEquip,
                currentPage: subEquipmentCurrentPage + 1,
                pageSize: subEquipmentRowsPerPage
            };
            
            dispatch(getSubEquipmentListPlanned(payloadSubEquip));
        }

        if(expandSubEquipmentID){
            const dataTask = {
                equipmentId: expandSubEquipmentID,
                areaId: 0,
                mainEquipmentId: 0
            };
    
            let payloadTask = {
                groupingParameter: dataTask,
                currentPage: tasksCurrentPage + 1,
                pageSize: tasksRowsPerPage
            };
            
            dispatch(getSubEquipmentsTaskListPlanned(payloadTask));
        }


        sessionStorage.setItem("mmsp_maintenanceTypeIds", JSON.stringify([]));
        sessionStorage.setItem("mmsp_startDate", JSON.stringify(Date.now()));
        sessionStorage.setItem("mmsp_endDate", JSON.stringify(Date.now()));
        sessionStorage.setItem("mmsp_includeOnlyLateTasks", JSON.stringify(false));
        sessionStorage.setItem("mmsp_poolIds", JSON.stringify([]));

        setDefaultState();
        
    };

    const HandleApplyFilter = () => {
        const dataArea = {
            equipmentId: 0,
            areaId: 0,
            mainEquipmentId: 0,
            breakdownEffectIds: [],
            breakdownReasonGroupIds: [],
            breakdownRootCauseIds: [],
            breakdownReasonPlaceIds: []
        };

        let payloadArea = { ...state,
            groupingParameter: dataArea,
            currentPage: mainEquipmentCurrentPage + 1,
            pageSize: areaGrouprowsPerPage
            
        };
        dispatch(getAreaGroupListPlanned(payloadArea));

        if(expandAreaID){
            const dataMainEquip = {
                equipmentId: 0,
                areaId: expandAreaID,
                mainEquipmentId: 0
            };
            let payloadMainEquip = { ...state,
                groupingParameter: dataMainEquip,
                currentPage: mainEquipmentCurrentPage + 1,
                pageSize: mainEquipmentRowsPerPage
            };
    
            dispatch(getMainEquipmentListPlanned(payloadMainEquip));
        }

        if(expandMainEquipmentID){
            const dataSubEquip = {
                equipmentId: 0,
                areaId: 0,
                mainEquipmentId: expandMainEquipmentID
            };
    
            let payloadSubEquip = { ...state,
                groupingParameter: dataSubEquip,
                currentPage: subEquipmentCurrentPage + 1,
                pageSize: subEquipmentRowsPerPage
            };
            
            dispatch(getSubEquipmentListPlanned(payloadSubEquip));
        }

        if(expandSubEquipmentID){
            const dataTask = {
                equipmentId: expandSubEquipmentID,
                areaId: 0,
                mainEquipmentId: 0
            };
    
            let payloadTask = { ...state,
                groupingParameter: dataTask,
                currentPage: tasksCurrentPage + 1,
                pageSize: tasksRowsPerPage
            };
            
            dispatch(getSubEquipmentsTaskListPlanned(payloadTask));
        }

        toggleDrawer(false);
        setIsFilterDrawerOpen(false);
    };

    const HandleMaintenanceType = (maintenanceType) => {
        let ids = [];
        maintenanceType.map((item) => ids.push(item.id));
        if (maintenanceType == null) {
            sessionStorage.removeItem("mmsp_maintenanceTypeIds");
        } else {
            sessionStorage.setItem("mmsp_maintenanceTypeIds", JSON.stringify(ids));
        }
        setState({ ...state, maintenanceTypeIds: ids });
    };

    const HandleStartDate = (startDate) => {
        if (startDate == null) {
            sessionStorage.removeItem("mmsp_startDate");
        } else {
            sessionStorage.setItem("mmsp_startDate", JSON.stringify(startDate));
        }
      
        startDate = moment(startDate).format("YYYY-MM-DD")
        setState({ ...state, plannedDate : {
            ...state.plannedDate,startDate
        } });

    };

    const HandleEndDate = (endDate) => {
        if (endDate == null) {
            sessionStorage.removeItem("mmsp_endDate");
        } else {
            sessionStorage.setItem("mmsp_endDate", JSON.stringify(endDate));
        }

        endDate = moment(endDate).format("YYYY-MM-DD")
        setState({ ...state, plannedDate : {
            ...state.plannedDate,endDate
        } });

    };

    const HandleLate = (includeOnlyLateTasks) => {
        if (includeOnlyLateTasks == null) {
            sessionStorage.removeItem("mmsp_includeOnlyLateTasks");
        } else {
            sessionStorage.setItem("mmsp_includeOnlyLateTasks", JSON.stringify(includeOnlyLateTasks));
        }
        setState({ ...state, includeOnlyLateTasks });

    };

    const HandlePool = (poolIds) => {
        let ids = [];
        poolIds.map((item) => ids.push(item.id));
        if (poolIds == null) {
            sessionStorage.removeItem("mmsp_poolIds");
        } else {
            sessionStorage.setItem("mmsp_poolIds", JSON.stringify(ids));
        }
        setState({ ...state, poolIds: ids });
    };

    const filter = () => {
        return (
            <DetailFilter
                HandleMaintenanceType = {HandleMaintenanceType}
                HandlePool={HandlePool}
                maintenanceType = {state.maintenanceTypeIds}
                maintenanceTypeData = {maintenanceTypeDataF}
                HandleLate={HandleLate}
                late={state.includeOnlyLateTasks}
                poolIds={state.poolIds}
                poolData={poolData}
                isAreaNotFiltered={true}
                HandleStartDate={HandleStartDate}
                startDate={state.plannedDate?.startDate}
                HandleEndDate={HandleEndDate}
                endDate={state.plannedDate?.endDate}
            />
        );
    };

    

    return (
        <StyledTableDiv>
             <FilterDrawer
                open={isFilterDrawerOpen}
                onOpen={toggleDrawer(true)}
                onClose={toggleDrawer(false)}
                HandleClearFilter={HandleClearFilter}
                HandleApplyFilter={HandleApplyFilter}
                detailFilter={filter()}
            />
            <FilterButton onClick={() => toggleDrawer(true)} />
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table" className={classes.areaTableCellStyle}>
                        <TableHead>
                            <TableRow>
                                {renderTableCell([
                                    { id: "", label: "" },
                                    { id: "areaName", label: t("Area") },
                                    { id: "areaGroupTaskCount", label: t("PlannedTotalTaskCount") },
                                    { id: "areaGroupAvgStartDuration", label: t("PlannedAverageStartingTime") },
                                    { id: "areaGroupAvgMaintDuration", label: t("PlannedAverageCompletionTime") },
                                ])}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {areaGroupData.map((row, rowIndex) => (
                                <React.Fragment>
                                    <TableRow id={`mmsl_TableRow_1_${rowIndex}`} key={row.id} className={classes.areaTableCellStyle}>
                                        <TableCell id={`mmsl_TableCell_1_expand`} style={{ padding: 0 }} className={classes.areaTableCellStyle}>
                                            <IconButton id={`mmsl_IconButton_${rowIndex}`} className={classes.expandArrowStyle} aria-label="expand row" size="small" onClick={() => expandAreaRow(row.areaId)}>
                                                {openAreaRow && expandAreaID === row.areaId ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                                            </IconButton>
                                        </TableCell>
                                        <TableCell align="center" className={classes.areaTableCellStyle} style={{ padding: 0 }}>
                                            {row.areaName}
                                        </TableCell>
                                        <TableCell align="center" className={classes.areaTableCellStyle}>{row.areaGroupTaskCount}</TableCell>
                                        <TableCell align="center" className={classes.areaTableCellStyle}>{Math.round(row.areaAvgStartDuration)}</TableCell>
                                        <TableCell align="center" className={classes.areaTableCellStyle}>{Math.round(row.areaAvgMaintDuration)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        {expandAreaID === row.areaId ? (
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                                <Collapse in={openAreaRow} timeout="auto" unmountOnExit>
                                                    <TableContainer component={Paper}>
                                                        <Table size="small" className={classes.mainEquipmentTableCellStyle}>
                                                            <TableHead>
                                                                <TableRow id={`mmsl_TableRow_2_${rowIndex}`}>
                                                                    {renderTableCell([
                                                                        { id: "", label: "" },
                                                                        { id: "mainEquipmentName", label: t("MainEquipment") },
                                                                        { id: "unPlannedTaskCount", label: t("PlannedTotalTaskCount") },
                                                                        { id: "unPlannedAvgStartDuration", label: t("PlannedAverageStartingTime") },
                                                                        { id: "unPlannedAvgMaintDuration", label: t("PlannedAverageCompletionTime") },
                                                                    ])}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {mainEquipmentData.map((row, itemIndex) => (
                                                                        <React.Fragment>
                                                                            <TableRow id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} key={row.id} className={classes.mainEquipmentTableCellStyle}>
                                                                                <TableCell id={`cig_TableCell_1_expand`}>
                                                                                    <IconButton
                                                                                        className={classes.expandArrowStyle}
                                                                                        id={`mmsl_IconButton_${rowIndex}`}
                                                                                        aria-label="expand row"
                                                                                        size="small"
                                                                                        onClick={() => expandMainEquipmentRow(row)}
                                                                                    >
                                                                                        {openMainEquipmentRow && expandMainEquipmentID === row.mainEquipmentId ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                                                                                    </IconButton>
                                                                                </TableCell>
                                                                                <TableCell id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} className={classes.mainEquipmentTableCellStyle} align="center" style={{}}>
                                                                                    {row.mainEquipmentName}
                                                                                </TableCell>
                                                                                <TableCell id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} className={classes.mainEquipmentTableCellStyle} align="center">{row.mainEquipmentTaskCount}</TableCell>
                                                                                <TableCell id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} className={classes.mainEquipmentTableCellStyle} align="center">{Math.round(row.mainEquipmentAvgStartDuration)}</TableCell>
                                                                                <TableCell id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} className={classes.mainEquipmentTableCellStyle} align="center">{Math.round(row.mainEquipmentAvgMaintDuration)}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                {expandMainEquipmentID === row.mainEquipmentId ? (
                                                                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                                                                        <Collapse in={openMainEquipmentRow} timeout="auto" unmountOnExit>
                                                                                            <TableContainer component={Paper}>
                                                                                                <Table size="small" className={classes.subEquipmentTableCellStyle}>
                                                                                                    <TableHead>
                                                                                                        <TableRow id={`mmsl_TableRow_2_${rowIndex}`}>
                                                                                                            {renderTableCell([
                                                                                                                { id: "", label: "" },
                                                                                                                { id: "subEquipmnetName", label: t("SubEquipment") },
                                                                                                                { id: "unPlannedTaskCount", label: t("PlannedTotalTaskCount") },
                                                                                                                { id: "unPlannedAvgStartDuration", label: t("PlannedAverageStartingTime") },
                                                                                                                { id: "unPlannedAvgMaintDuration", label: t("PlannedAverageCompletionTime") },
                                                                                                            ])}
                                                                                                        </TableRow>
                                                                                                    </TableHead>
                                                                                                    <TableBody>
                                                                                                        {subEquipmentData.map((row, itemIndex) => (
                                                                                                                <React.Fragment>
                                                                                                                    <TableRow
                                                                                                                        id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`}
                                                                                                                        key={row.id}
                                                                                                                        className={classes.subEquipmentTableCellStyle}
                                                                                                                    >
                                                                                                                        <TableCell id={`mmsl_TableCell_1_expand`}>
                                                                                                                            <IconButton
                                                                                                                                className={classes.expandArrowStyle}
                                                                                                                                id={`mmsl_IconButton_${rowIndex}`}
                                                                                                                                aria-label="expand row"
                                                                                                                                size="small"
                                                                                                                                onClick={() => expandSubEquipmentRow(row)}
                                                                                                                            >
                                                                                                                                {openSubEquipmentRow && expandSubEquipmentID === row.equipmentId ? (
                                                                                                                                    <KeyboardArrowDown />
                                                                                                                                ) : (
                                                                                                                                    <KeyboardArrowRight />
                                                                                                                                )}
                                                                                                                            </IconButton>
                                                                                                                        </TableCell>
                                                                                                                        <TableCell className={classes.subEquipmentTableCellStyle} align="center" style={{}}>
                                                                                                                            {row.subEquipmentName}
                                                                                                                        </TableCell>
                                                                                                                        <TableCell className={classes.subEquipmentTableCellStyle} align="center">{row.subEquipmentTaskCount}</TableCell>
                                                                                                                        <TableCell className={classes.subEquipmentTableCellStyle} align="center">{Math.round(row.subEquipmentAvgStartDuration)}</TableCell>
                                                                                                                        <TableCell className={classes.subEquipmentTableCellStyle} align="center">{Math.round(row.subEquipmentAvgMaintDuration)}</TableCell>
                                                                                                                    </TableRow>
                                                                                                                    <TableRow>
                                                                                                                        {expandSubEquipmentID === row.equipmentId ? (
                                                                                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                                                                                                                <Collapse in={openSubEquipmentRow} timeout="auto" unmountOnExit>
                                                                                                                                    <div style={{ width: "100%", textAlign: "center" }}>
                                                                                                                                        <DataGrid
                                                                                                                                            autoHeight={true}
                                                                                                                                            rows={subEqTaskList}
                                                                                                                                            columns={getTableColumns(true)}
                                                                                                                                            pageSize={tasksRowsPerPage}
                                                                                                                                            onPageSizeChange={tasksHandleChangeRowsPerPage}
                                                                                                                                            onPageChange={tasksHandleChangePage}
                                                                                                                                            rowsPerPageOptions={[5, 10, 20, 50]}
                                                                                                                                            rowCount={subEqTaskListCount} //total count
                                                                                                                                            page={tasksCurrentPage}
                                                                                                                                            paginationMode="server"
                                                                                                                                            disableColumnFilter
                                                                                                                                            disableColumnMenu
                                                                                                                                            getRowId={(row) => row.id}
                                                                                                                                            onRowClick={(param) => {
                                                                                                                                                NavigateToDetails(param.id);
                                                                                                                                            }}
                                                                                                                                            components={{
                                                                                                                                                Toolbar: customToolbar,
                                                                                                                                                NoRowsOverlay: noRowsTemplate,
                                                                                                                                                LoadingOverlay: LinearProgress,
                                                                                                                                            }}
                                                                                                                                            loading={loading}                                                                                                                                            {...false}
                                                                                                                                            filterMode="server"
                                                                                                                                            columnVisibilityModel={columnVisibilityModel}
                                                                                                                                            onColumnVisibilityModelChange={(newModel) =>
                                                                                                                                                handleChangeVisibility(newModel)
                                                                                                                                            }
                                                                                                                                            onSortModelChange={(sortModel) => handleSort(sortModel)}
                                                                                                                                            sx={{
                                                                                                                                                boxShadow: 5,
                                                                                                                                                "& .MuiDataGrid-row:hover": {
                                                                                                                                                    color: "primary.main",
                                                                                                                                                },
                                                                                                                                                "& .MuiDataGrid-row": {
                                                                                                                                                    color: "black",
                                                                                                                                                },
                                                                                                                                                "& .MuiDataGrid-columnSeparator": {
                                                                                                                                                    display: "none",
                                                                                                                                                },
                                                                                                                                                "& .MuiTablePagination-toolbar": {
                                                                                                                                                    color: "black",
                                                                                                                                                }
                                                                                                                                            }}
                                                                                                                                            localeText={{
                                                                                                                                                toolbarColumns: t("Columns"),
                                                                                                                                                columnsPanelTextFieldLabel:
                                                                                                                                                    t("ColumnsPanelTextFieldLabel"),
                                                                                                                                                columnsPanelTextFieldPlaceholder:
                                                                                                                                                    t("ColumnsPanelTextFieldPlaceholder"),
                                                                                                                                                columnsPanelShowAllButton:
                                                                                                                                                    t("ColumnsPanelShowAllButton"),
                                                                                                                                                columnsPanelHideAllButton:
                                                                                                                                                    t("ColumnsPanelHideAllButton"),
                                                                                                                                                toolbarDensity: t("Density"),
                                                                                                                                                toolbarDensityCompact: t("DensityCompact"),
                                                                                                                                                toolbarDensityStandard: t("DensityStandard"),
                                                                                                                                                toolbarDensityComfortable: t("DensityComfortable"),
                                                                                                                                            }}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                </Collapse>
                                                                                                                            </TableCell>
                                                                                                                        ) : null}
                                                                                                                    </TableRow>
                                                                                                                </React.Fragment>
                                                                                                            ))}
                                                                                                    </TableBody>
                                                                                                </Table>
                                                                                                <TablePagination
                                                                                                    id="mmtl_SubEquipmentPagination"
                                                                                                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                                                                                    component="div"
                                                                                                    count={subEquipmentCount}
                                                                                                    rowsPerPage={subEquipmentRowsPerPage}
                                                                                                    page={subEquipmentCurrentPage}
                                                                                                    onPageChange={subEquipmentHandleChangePage}
                                                                                                    onRowsPerPageChange={subEquipmentHandleChangeRowsPerPage}
                                                                                                    className={classes.subEquipmentTableCellStyle}
                                                                                                />
                                                                                            </TableContainer>
                                                                                        </Collapse>
                                                                                    </TableCell>
                                                                                ) : null}
                                                                            </TableRow>
                                                                        </React.Fragment>
                                                                    ))}
                                                            </TableBody>
                                                        </Table>
                                                        <TablePagination
                                                            id="mmtl_MainEquipmentPagination"
                                                            rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                                            component="div"
                                                            count={mainEquipmentCount}
                                                            rowsPerPage={mainEquipmentRowsPerPage}
                                                            page={mainEquipmentCurrentPage}
                                                            onPageChange={mainEquipmentHandleChangePage}
                                                            onRowsPerPageChange={mainEquipmentHandleChangeRowsPerPage}
                                                            className={classes.mainEquipmentTableCellStyle}
                                                        />
                                                    </TableContainer>
                                                </Collapse>
                                            </TableCell>
                                        ) : null}
                                    </TableRow>
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        id="mmtl_AreaGroupPagination"
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        component="div"
                        count={areaGroupCount}
                        rowsPerPage={areaGrouprowsPerPage}
                        page={areaGroupCurrentPage}
                        onPageChange={areaGroupHandleChangePage}
                        onRowsPerPageChange={areaGroupHandleChangeRowsPerPage}
                        className={classes.areaTableCellStyle}
                    />
                </TableContainer>
            </Grow>
            <LoadingBackdrop />
        </StyledTableDiv>
    );
}
